const init = () => {
  const node = document.createElement('section');
  node.classList.add('gui-toast-group');

  document.firstElementChild.insertBefore(node, document.body);
  return node;
};

const Toaster = init();

const createToast = (text, type) => {
  const node = document.createElement('output');
  const nodeText = document.createElement('p');
  const nodeIcon = document.createElement('span');

  nodeText.innerHTML = text;
  nodeIcon.innerHTML = `<svg viewBox="0 0 24 24" fill="currentColor"
  xmlns="http://www.w3.org/2000/svg">
  <g id="Complete">
    <g id="info-circle">
      <g>
        <circle cx="12" cy="12" data-name="--Circle" fill="none" id="_--Circle" r="10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        <line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="12" x2="12" y1="12" y2="16"/>
        <line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="12" x2="12" y1="8" y2="8"/>
      </g>
    </g>
  </g>
 </svg>`;
  node.appendChild(nodeIcon);
  node.appendChild(nodeText);
  nodeIcon.classList.add('gui-toast__icon');
  node.classList.add('gui-toast');
  node.setAttribute('data-type', type);
  node.setAttribute('role', 'status');

  return node;
};

const addToast = (toast) => {
  const { matches: motionOK } = window.matchMedia(
    '(prefers-reduced-motion: no-preference)'
  );

  Toaster.children.length && motionOK
    ? flipToast(toast)
    : Toaster.insertBefore(toast, Toaster.firstChild);
};

const flipToast = (toast) => {
  // FIRST
  const first = Toaster.offsetHeight;

  // add new child to change container size
  Toaster.insertBefore(toast, Toaster.firstChild);

  // LAST
  const last = (Toaster.children.length - 1) * 85;

  // INVERT
  const invert = last - first;

  // PLAY
  const animation = Toaster.animate(
    [{ transform: `translateY(${invert}px)` }, { transform: 'translateY(0)' }],
    {
      duration: 150,
      easing: 'ease-out'
    }
  );
};

const Toast = (text, type) => {
  let toast = createToast(text, type);
  addToast(toast);

  return new Promise(async (resolve, reject) => {
    await Promise.allSettled(
      toast.getAnimations().map((animation) => animation.finished)
    );
    Toaster.removeChild(toast);
    resolve();
  });
};

export default Toast;
